export default __webpack_public_path__ + "static/media/DSCN1689.646ea751.JPG";